import {
  Building2, Users, Briefcase, Package, Target, Crosshair,
  TrendingUp, MonitorPlay, Search, MessageCircle, Database,
  Bot, Image as ImageIcon, Star, CreditCard,
  Target as Goal, FileText, Brain
} from 'lucide-react';

export const navigationGroups = [
  {
    title: "Perfil & Estrutura",
    items: [
      { id: "m1", title: "Dados da Empresa", icon: Building2 },
      { id: "m2", title: "Responsáveis", icon: Users },
      { id: "m3", title: "Negócio", icon: Briefcase },
    ]
  },
  {
    title: "Oferta & Mercado",
    items: [
      { id: "m4", title: "Produtos e Serviços", icon: Package },
      { id: "m5", title: "Cliente Ideal", icon: Target },
      { id: "m6", title: "Concorrência", icon: Crosshair },
    ]
  },
  {
    title: "Vendas & Processos",
    items: [
      { id: "m7", title: "Processo Comercial", icon: TrendingUp },
      { id: "m15", title: "Financeiro", icon: CreditCard },
      { id: "m16", title: "Objetivos & Metas", icon: Goal },
    ]
  },
  {
    title: "Documentos",
    items: [
      { id: "m17", title: "Planilhas & Contratos", icon: FileText },
    ]
  },
  {
    title: "Inteligência",
    items: [
      { id: "m12", title: "IA e Automações", icon: Bot },
      { id: "m18", title: "Central de Conhecimento", icon: Brain },
    ]
  }
];

export const getModuleTitle = (id: string) => {
  for (const group of navigationGroups) {
    const item = group.items.find(i => i.id === id);
    if (item) return item.title;
  }
  return "Módulo Desconhecido";
};
